import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { observable, makeObservable, runInAction, computed, action, configure, when } from "mobx";
import Network from "./Network";
import Base from "./Base";
import User from "./User";
import Messages from "./Messages";
import Payment from "./Payment";
import Checkout from "./Checkout";
import GCCheckout from "./GCCheckout";
import Common from "./Common";
import MobilePay from "./MobilePay";
import Restaurant from "./Restaurant";
import Curbside from "./Curbside";
import Delivery from "./Delivery";
import MenuList from "./MenuList";
import Reservation from "./Reservation";
import OrderConfirmation from "./OrderConfirmation";
import JoinWaitlist from "./JoinWaitlist";
import PrivateDining from "./PrivateDining";
import { handle, ORDER_TYPES } from "@dp/common";
import { clearExpiredCacheEntries } from "../utils/cache";
import DineInOrder from "./DineInOrder";
import OrderStatus from "./OrderStatus";
import PayNow from "./PayNow";
import WaitListVisibility from "./WaitListVisibility";
import WineList from "./WineList";
import WineLocker from "./WineLocker";
import BrandRules from "../utils/BrandRules";
var Root = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Root, _Base);

  var _super = _createSuper(Root);

  _createClass(Root, [{
    key: "marketingCloudVisitorId",
    // public cart: Cart;
    // Ensure components update on first instantiation
    // This is required for the header, which does not call initComponent
    value: function marketingCloudVisitorId() {
      return this._marketingCloudVisitorId;
    }
  }, {
    key: "applicationVersion",
    get: function get() {
      return this._applicationVersion;
    }
  }, {
    key: "isMobile",
    get: function get() {
      return this.winWidth < 768;
    }
  }, {
    key: "acceptClientType",
    get: function get() {
      return this.isMobile ? "mobile-togo-tokenizecard" : "desktop-togo-tokenizecard";
    }
  }]);

  function Root(platformUtil) {
    var _this;

    _classCallCheck(this, Root);

    _this = _super.call(this);

    _initializerDefineProperty(_assertThisInitialized(_this), "error", _descriptor, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "network", void 0);

    _defineProperty(_assertThisInitialized(_this), "user", void 0);

    _defineProperty(_assertThisInitialized(_this), "checkout", void 0);

    _defineProperty(_assertThisInitialized(_this), "gcCheckout", void 0);

    _defineProperty(_assertThisInitialized(_this), "mobilePay", void 0);

    _defineProperty(_assertThisInitialized(_this), "curbside", void 0);

    _defineProperty(_assertThisInitialized(_this), "appMessages", void 0);

    _defineProperty(_assertThisInitialized(_this), "payment", void 0);

    _defineProperty(_assertThisInitialized(_this), "restaurant", void 0);

    _defineProperty(_assertThisInitialized(_this), "common", void 0);

    _defineProperty(_assertThisInitialized(_this), "delivery", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderConfirmation", void 0);

    _defineProperty(_assertThisInitialized(_this), "dineInOrder", void 0);

    _defineProperty(_assertThisInitialized(_this), "orderStatus", void 0);

    _defineProperty(_assertThisInitialized(_this), "payNow", void 0);

    _defineProperty(_assertThisInitialized(_this), "waitListVisibility", void 0);

    _defineProperty(_assertThisInitialized(_this), "joinWaitlist", void 0);

    _defineProperty(_assertThisInitialized(_this), "reservation", void 0);

    _defineProperty(_assertThisInitialized(_this), "privateDining", void 0);

    _defineProperty(_assertThisInitialized(_this), "wineList", void 0);

    _defineProperty(_assertThisInitialized(_this), "wineLocker", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "menuList", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "platformUtil", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "_refreshInProgress", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_initInProgress", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_winWidth", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_winHeight", _descriptor6, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_documentHeight", _descriptor7, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_styleCode", _descriptor8, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_keyboardShown", _descriptor9, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_lastPauseTimeStamp", _descriptor10, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_marketingCloudVisitorId", _descriptor11, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "reloadInProgress", _descriptor12, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_showLocationPermissionPopup", _descriptor13, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "_timeSinceStartup", _descriptor14, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "_applicationVersion", void 0);

    _this.platformUtil = platformUtil;
    _this.appMessages = new Messages(_assertThisInitialized(_this));
    _this.common = new Common(_assertThisInitialized(_this));
    _this.network = new Network(_assertThisInitialized(_this));
    _this.user = new User(_assertThisInitialized(_this));
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Root, [{
    key: "clearAll",
    value: function clearAll() {
      this.initInProgress = false;
      this.refreshInProgress = false;
      this.appMessages = new Messages(this);
      this.common = new Common(this);
      this.user = new User(this);
      this.joinWaitlist = new JoinWaitlist(this);
      this.menuList = null;
      this.checkout = null;
      this.gcCheckout = null;
      this.mobilePay = null;
      this.curbside = null;
      this.payment = null;
      this.restaurant = null;
      this.delivery = null;
      this.orderConfirmation = null;
      this.dineInOrder = null;
      this.orderStatus = null;
      this.payNow = null;
      this.waitListVisibility = null;
      this.reservation = null;
      this.privateDining = null;
      this.wineList = null;
      this.wineLocker = null;
    }
  }, {
    key: "reloadApp",
    value: function () {
      var _reloadApp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(postLogin) {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.reloadInProgress) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (postLogin && postLogin.disableAutoLogin) {
                  this.user.loginModal.disableAutoLogin = true;
                }

                runInAction(function () {
                  _this2.reloadInProgress = true;
                });
                _context.next = 6;
                return when(function () {
                  return _this2.reloadInProgress;
                });

              case 6:
                this.clearAll();
                _context.next = 9;
                return this.init();

              case 9:
                _context.next = 11;
                return this.initComponent("MAPP");

              case 11:
                this.lastPauseTimeStamp = null;
                runInAction(function () {
                  _this2.reloadInProgress = false;
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function reloadApp(_x) {
        return _reloadApp.apply(this, arguments);
      }

      return reloadApp;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      return;
    }
  }, {
    key: "onAppLayout",
    value: function onAppLayout(event) {
      if (event) {
        this._winHeight = event.height;
        this._winWidth = event.width;

        if (!(event.keyboardShown === null || event.keyboardShown === undefined)) {
          this._keyboardShown = event.keyboardShown;
        }
      }
    }
  }, {
    key: "onStateChange",
    value: function () {
      var _onStateChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(appState) {
        var didAppReload, currentTime, pauseTime, _this$common, _this$user, _this$user$sessionDet, _this$user$sessionDet2, _this$menuList, promises;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.initInProgress) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                didAppReload = false;
                currentTime = Date.now();
                pauseTime = this.lastPauseTimeStamp ? currentTime - this.lastPauseTimeStamp : 0;

                if (appState === "active") {
                  // check sessionID for analytics when app is in foreground
                  (_this$common = this.common) === null || _this$common === void 0 ? void 0 : _this$common.trackSession();
                }

                if (!(appState === "active" && pauseTime > 1.5 * 1000)) {
                  _context2.next = 31;
                  break;
                }

                if (!(pauseTime > 15 * 60 * 1000)) {
                  _context2.next = 13;
                  break;
                }

                _context2.next = 10;
                return this.reloadApp({
                  disableAutoLogin: false
                });

              case 10:
                didAppReload = true;
                _context2.next = 19;
                break;

              case 13:
                if (!(pauseTime > 5 * 60 * 1000)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return this.user.refreshSessionDetails();

              case 16:
                if (!((_this$user = this.user) !== null && _this$user !== void 0 && (_this$user$sessionDet = _this$user.sessionDetails) !== null && _this$user$sessionDet !== void 0 && (_this$user$sessionDet2 = _this$user$sessionDet.restaurantDetails) !== null && _this$user$sessionDet2 !== void 0 && _this$user$sessionDet2.restaurantId)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 19;
                return (_this$menuList = this.menuList) === null || _this$menuList === void 0 ? void 0 : _this$menuList.fetchTimes();

              case 19:
                if (didAppReload) {
                  _context2.next = 29;
                  break;
                }

                promises = [];

                if (!this.user) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return this.user.whenAppActive();

              case 24:
                if (this.menuList) {
                  promises.push(this.menuList.whenAppActive());
                }

                if (this.curbside) {
                  promises.push(this.curbside.whenAppActive());
                }

                if (this.waitListVisibility) {
                  promises.push(this.waitListVisibility.whenAppActive());
                }

                _context2.next = 29;
                return handle(Promise.all(promises));

              case 29:
                _context2.next = 32;
                break;

              case 31:
                this.lastPauseTimeStamp = Date.now();

              case 32:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onStateChange(_x2) {
        return _onStateChange.apply(this, arguments);
      }

      return onStateChange;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var stores, promises, cloudId;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._applicationVersion = this.platformUtil.getApplicationVersion();

                if (this.initInProgress) {
                  _context3.next = 14;
                  break;
                }

                this.initInProgress = true;
                stores = _objectSpread({}, this);
                promises = Object.keys(stores).filter(function (key) {
                  return typeof stores[key] === "object";
                }) // Change this. Not a Good Solve.
                .map(function (key) {
                  var store = stores[key];

                  if (store) {
                    if (typeof store.setupReactions === "function") {
                      store.setupReactions();
                    }

                    if (typeof store.init === "function") {
                      return store.init();
                    } else {
                      return Promise.resolve();
                    }
                  } else {
                    return Promise.resolve();
                  }
                });
                _context3.next = 7;
                return clearExpiredCacheEntries(this.platformUtil);

              case 7:
                _context3.next = 9;
                return Promise.all(promises);

              case 9:
                _context3.next = 11;
                return this.platformUtil.getMarketingCloudId();

              case 11:
                cloudId = _context3.sent;
                runInAction(function () {
                  _this3._marketingCloudVisitorId = cloudId;
                });
                this.initInProgress = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "initComponent",
    value: function () {
      var _initComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(componentName) {
        var _this4 = this;

        var reInit,
            reuse,
            stores,
            _this$user2,
            _this$user2$sessionDe,
            _this$user2$sessionDe2,
            promises,
            cloudId,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                reInit = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                reuse = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : true;
                stores = [];

                if (componentName === "Checkout") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!(reuse && this.checkout)) {
                    this.checkout = new Checkout(this);
                    stores.push(this.checkout);
                  } else {
                    if (reInit) {
                      stores.push(this.checkout);
                    }
                  }
                }

                if (componentName === "GCCheckout") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!(reuse && this.gcCheckout)) {
                    this.gcCheckout = new GCCheckout(this);
                    stores.push(this.gcCheckout);
                  } else {
                    if (reInit) {
                      stores.push(this.gcCheckout);
                    }
                  }
                }

                if (componentName === "MobilePay") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!(reuse && this.mobilePay)) {
                    this.mobilePay = new MobilePay(this);
                    stores.push(this.mobilePay);
                  } else {
                    if (reInit) {
                      stores.push(this.mobilePay);
                    }
                  }
                } // eslint-disable-next-line sonarjs/no-collapsible-if


                if (componentName === "Curbside") {
                  if (!(reuse && this.curbside)) {
                    this.curbside = new Curbside(this);
                    stores.push(this.curbside);
                  } else {
                    if (reInit) {
                      stores.push(this.curbside);
                    }
                  } //NOOP

                }

                if (componentName === "Menu") {
                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }

                  if (!this.dineInOrder) {
                    this.dineInOrder = new DineInOrder(this);
                    stores.push(this.dineInOrder);
                  }
                }

                if (componentName === "MAPP") {
                  if (!this.joinWaitlist) {
                    this.joinWaitlist = new JoinWaitlist(this);
                    stores.push(this.joinWaitlist);
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }

                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.payment)) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  } else {
                    if (reInit) {
                      stores.push(this.payment);
                    }
                  }

                  if (!(reuse && this.curbside)) {
                    this.curbside = new Curbside(this);
                    stores.push(this.curbside);
                  } else {
                    if (reInit) {
                      stores.push(this.curbside);
                    }
                  }

                  if (!this.reservation) {
                    this.reservation = new Reservation(this);
                    stores.push(this.reservation);
                  }

                  if (this.isWineListAvailable) {
                    if (!this.wineList) {
                      this.wineList = new WineList(this);
                      stores.push(this.wineList);
                    } else {
                      if (reInit) {
                        stores.push(this.wineList);
                      }
                    }
                  }

                  if (this.isWineLockerAvailable) {
                    if (!this.wineLocker) {
                      this.wineLocker = new WineLocker(this);
                      stores.push(this.wineLocker);
                    } else {
                      if (reInit) {
                        stores.push(this.wineLocker);
                      }
                    }
                  } //only init DineInOrder store if exisitng OA flow is in-progress


                  if ((this === null || this === void 0 ? void 0 : (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : (_this$user2$sessionDe = _this$user2.sessionDetails) === null || _this$user2$sessionDe === void 0 ? void 0 : (_this$user2$sessionDe2 = _this$user2$sessionDe.orderContext) === null || _this$user2$sessionDe2 === void 0 ? void 0 : _this$user2$sessionDe2.orderTypeValue) === ORDER_TYPES.ORDER_AHEAD) {
                    if (!this.dineInOrder) {
                      this.dineInOrder = new DineInOrder(this);
                      stores.push(this.dineInOrder);
                    } else {
                      if (reInit) {
                        stores.push(this.dineInOrder);
                      }
                    }
                  }
                }

                if (componentName === "Delivery") {
                  if (!(reuse && this.delivery)) {
                    this.delivery = new Delivery(this);
                    stores.push(this.delivery);
                  } else {
                    if (reInit) {
                      stores.push(this.delivery);
                    }
                  }
                }

                if (componentName === "ToGoDelivery") {
                  if (!(reuse && this.delivery)) {
                    this.delivery = new Delivery(this, true);
                    stores.push(this.delivery);
                  } else {
                    if (reInit) {
                      stores.push(this.delivery);
                    }
                  }
                }

                if (componentName === "WaitListVisibility") {
                  if (!(reuse && this.waitListVisibility)) {
                    this.waitListVisibility = new WaitListVisibility(this);
                    stores.push(this.waitListVisibility);
                  } else {
                    if (reInit) {
                      stores.push(this.waitListVisibility);
                    }
                  }
                }

                if (componentName === "OrderConfirmation") {
                  if (!(reuse && this.orderConfirmation)) {
                    this.orderConfirmation = new OrderConfirmation(this);
                    stores.push(this.orderConfirmation);
                  } else {
                    if (reInit) {
                      stores.push(this.orderConfirmation);
                    }
                  }

                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }
                }

                if (componentName === "RestaurantDetails") {
                  if (!this.menuList) {
                    this.menuList = new MenuList(this, false, true);
                    stores.push(this.menuList);
                  }

                  if (!this.restaurant) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  }

                  if (!this.joinWaitlist) {
                    this.joinWaitlist = new JoinWaitlist(this);
                    stores.push(this.joinWaitlist);
                  }
                }

                if (componentName === "JoinWaitlist") {
                  if (!this.joinWaitlist) {
                    this.joinWaitlist = new JoinWaitlist(this);
                    stores.push(this.joinWaitlist);
                  }
                }

                if (componentName === "Reservations") {
                  if (!this.reservation) {
                    this.reservation = new Reservation(this);
                    stores.push(this.reservation);
                  }
                }

                if (componentName === "LocationSearch") {
                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      // TODO:: Have a separate Store for Order Settings
                      _this4.menuList = new MenuList(_this4, false, false, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }

                  if (!this.joinWaitlist) {
                    this.joinWaitlist = new JoinWaitlist(this, true);
                    stores.push(this.joinWaitlist);
                  }
                }

                if (componentName === "DineInOrder") {
                  if (!this.dineInOrder) {
                    this.dineInOrder = new DineInOrder(this);
                    stores.push(this.dineInOrder);
                  }

                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }
                }

                if (componentName === "OrderStatus") {
                  if (!(reuse && this.orderStatus)) {
                    this.orderStatus = new OrderStatus(this);
                    stores.push(this.orderStatus);
                  } else {
                    if (reInit) {
                      stores.push(this.orderStatus);
                    }
                  }
                }

                if (componentName === "PayNow") {
                  if (!(reuse && this.payNow)) {
                    this.payNow = new PayNow(this);
                    stores.push(this.payNow);
                  } else {
                    if (reInit) {
                      stores.push(this.payNow);
                    }
                  }
                }

                if (componentName === "MyAccount") {
                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4, false, false, false, false, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.payment)) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  } else {
                    if (reInit) {
                      stores.push(this.payment);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }
                }

                if (componentName === "Eclub") {
                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4, false, false, false, false, false, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }
                }

                if (componentName === "PrivateDining") {
                  if (!(reuse && this.privateDining)) {
                    this.privateDining = new PrivateDining(this);
                    stores.push(this.privateDining);
                  } else {
                    if (reInit) {
                      stores.push(this.privateDining);
                    }
                  }

                  if (!(reuse && this.menuList)) {
                    runInAction(function () {
                      _this4.menuList = new MenuList(_this4, false, false, false, true);
                    });
                    stores.push(this.menuList);
                  } else {
                    if (reInit) {
                      stores.push(this.menuList);
                    }
                  }

                  if (!(reuse && this.restaurant)) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  } else {
                    if (reInit) {
                      stores.push(this.restaurant);
                    }
                  }
                }

                if (!stores.length) {
                  _context4.next = 33;
                  break;
                }

                this.initInProgress = true;
                promises = stores.map(function (store) {
                  if (store) {
                    if (typeof store.setupReactions === "function") {
                      store.setupReactions();
                    }

                    if (typeof store.init === "function") {
                      return store.init();
                    } else {
                      return Promise.resolve();
                    }
                  } else {
                    return Promise.resolve();
                  }
                });
                _context4.next = 28;
                return Promise.all(promises);

              case 28:
                _context4.next = 30;
                return this.platformUtil.getMarketingCloudId();

              case 30:
                cloudId = _context4.sent;
                runInAction(function () {
                  _this4._marketingCloudVisitorId = cloudId;
                });
                this.initInProgress = false;

              case 33:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initComponent(_x3) {
        return _initComponent.apply(this, arguments);
      }

      return initComponent;
    }()
  }, {
    key: "refreshComponent",
    value: function () {
      var _refreshComponent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(componentName) {
        var _this5 = this;

        var stores, promises, cloudId;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                stores = [];

                if (componentName === "Checkout") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!this.checkout) {
                    this.checkout = new Checkout(this);
                    stores.push(this.checkout);
                  }
                }

                if (componentName === "GCCheckout") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!this.checkout) {
                    this.gcCheckout = new GCCheckout(this);
                    stores.push(this.gcCheckout);
                  }
                }

                if (componentName === "MobilePay") {
                  if (!this.payment) {
                    this.payment = new Payment(this);
                    stores.push(this.payment);
                  }

                  if (!this.mobilePay) {
                    this.mobilePay = new MobilePay(this);
                    stores.push(this.mobilePay);
                  }
                }

                if (componentName === "Menu") {
                  if (!this.menuList) {
                    runInAction(function () {
                      _this5.menuList = new MenuList(_this5);
                    });
                    stores.push(this.menuList);
                  }

                  if (!this.restaurant) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  }
                } // eslint-disable-next-line sonarjs/no-collapsible-if


                if (componentName === "Curbside") {
                  if (!this.curbside) {
                    this.curbside = new Curbside(this);
                    stores.push(this.curbside);
                  }
                }

                if (componentName === "MAPP") {
                  if (!this.menuList) {
                    runInAction(function () {
                      _this5.menuList = new MenuList(_this5);
                    });
                    stores.push(this.menuList);
                  }

                  if (!this.restaurant) {
                    this.restaurant = new Restaurant(this);
                    stores.push(this.restaurant);
                  }
                }

                if (!(stores.length && !(this.refreshInProgress || this.initInProgress))) {
                  _context5.next = 17;
                  break;
                }

                this.refreshInProgress = true;
                promises = stores.map(function (store) {
                  if (store) {
                    if (typeof store.refresh === "function") {
                      return store.refresh();
                    } else {
                      return Promise.resolve();
                    }
                  } else {
                    return Promise.resolve();
                  }
                });
                _context5.next = 12;
                return Promise.all(promises);

              case 12:
                _context5.next = 14;
                return this.platformUtil.getMarketingCloudId();

              case 14:
                cloudId = _context5.sent;
                runInAction(function () {
                  _this5._marketingCloudVisitorId = cloudId;
                });
                this.refreshInProgress = false;

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function refreshComponent(_x4) {
        return _refreshComponent.apply(this, arguments);
      }

      return refreshComponent;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this6 = this;

        var stores, promises, cloudId;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                this.refreshInProgress = true;
                stores = _objectSpread({}, this);
                promises = Object.keys(stores).filter(function (key) {
                  return typeof stores[key] === "object";
                }) // Change this. Not a Good Solve.
                .map(function (key) {
                  var store = stores[key];

                  if (store) {
                    if (typeof store.refresh === "function") {
                      return store.refresh();
                    } else {
                      return Promise.resolve();
                    }
                  } else {
                    return Promise.resolve();
                  }
                });
                _context6.next = 5;
                return Promise.all(promises);

              case 5:
                _context6.next = 7;
                return this.platformUtil.getMarketingCloudId();

              case 7:
                cloudId = _context6.sent;
                runInAction(function () {
                  _this6._marketingCloudVisitorId = cloudId;
                });
                this.refreshInProgress = false;

              case 10:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "onGeoFenceStateChange",
    value: function onGeoFenceStateChange(taskId, geofenceNotification) {
      var _this$menuList2;

      (_this$menuList2 = this.menuList) === null || _this$menuList2 === void 0 ? void 0 : _this$menuList2.validateGeoFence(taskId, geofenceNotification);
    }
  }, {
    key: "onDeviceNotification",
    value: function () {
      var _onDeviceNotification = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(notification) {
        var _this$menuList3;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                (_this$menuList3 = this.menuList) === null || _this$menuList3 === void 0 ? void 0 : _this$menuList3.handleOnDeviceNotification();

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onDeviceNotification(_x5) {
        return _onDeviceNotification.apply(this, arguments);
      }

      return onDeviceNotification;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var stores, promises;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this.refreshInProgress) {
                  _context8.next = 7;
                  break;
                }

                this.refreshInProgress = true;
                stores = _objectSpread({}, this);
                promises = Object.keys(stores).filter(function (key) {
                  return typeof stores[key] === "object";
                }) // Change this. Not a Good Solve.
                .map(function (key) {
                  var store = stores[key];

                  if (store) {
                    return store.reset();
                  } else {
                    return Promise.resolve();
                  }
                });
                _context8.next = 6;
                return Promise.all(promises);

              case 6:
                this.refreshInProgress = false;

              case 7:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "clearError",
    value: function clearError() {
      if (this.error) {
        this.error = null;
      }
    }
  }, {
    key: "showError",
    value: function showError(error) {
      if (error) {
        this.error = error;
      }
    }
  }, {
    key: "loadMobXconfig",
    value: function loadMobXconfig(configOptions) {
      configure(configOptions);
    }
  }, {
    key: "timeSinceStartup",
    set: function set(time) {
      var _this7 = this;

      runInAction(function () {
        _this7._timeSinceStartup = time;
      });
    },
    get: function get() {
      return this._timeSinceStartup ? this._timeSinceStartup : 0;
    }
  }, {
    key: "lastPauseTimeStamp",
    get: function get() {
      return this._lastPauseTimeStamp;
    },
    set: function set(val) {
      var _this8 = this;

      runInAction(function () {
        _this8._lastPauseTimeStamp = val;
      });
    }
  }, {
    key: "keyboardShow",
    get: function get() {
      return this._keyboardShown;
    }
  }, {
    key: "refreshInProgress",
    get: function get() {
      return this._refreshInProgress;
    },
    set: function set(val) {
      var _this9 = this;

      runInAction(function () {
        _this9._refreshInProgress = val;
      });
    }
  }, {
    key: "initInProgress",
    get: function get() {
      return this._initInProgress;
    },
    set: function set(val) {
      var _this10 = this;

      runInAction(function () {
        _this10._initInProgress = val;
      });
    }
  }, {
    key: "winWidth",
    get: function get() {
      return this._winWidth;
    },
    set: function set(winWidth) {
      var _this11 = this;

      runInAction(function () {
        _this11._winWidth = winWidth;
      });
    }
  }, {
    key: "styleCode",
    get: function get() {
      return this._styleCode;
    },
    set: function set(val) {
      var _this12 = this;

      runInAction(function () {
        _this12._styleCode = val;
      });
    }
  }, {
    key: "winHeight",
    get: function get() {
      return this._winHeight;
    },
    set: function set(winHeight) {
      var _this13 = this;

      runInAction(function () {
        _this13._winHeight = winHeight;
      });
    }
  }, {
    key: "documentHeight",
    get: function get() {
      return this._documentHeight;
    },
    set: function set(documentHeight) {
      var _this14 = this;

      runInAction(function () {
        _this14._documentHeight = documentHeight;
      });
    }
  }, {
    key: "orientation",
    get: function get() {
      return this._winWidth > this._winHeight ? "LANDSCAPE" : "PORTRAIT";
    }
  }, {
    key: "isWineListAvailable",
    get: function get() {
      var _this$common2;

      return new BrandRules((_this$common2 = this.common) === null || _this$common2 === void 0 ? void 0 : _this$common2.appAttributes.currentConceptCode).isWineListAvailable();
    }
  }, {
    key: "isWineLockerAvailable",
    get: function get() {
      var _this$common3;

      return new BrandRules((_this$common3 = this.common) === null || _this$common3 === void 0 ? void 0 : _this$common3.appAttributes.currentConceptCode).isWineLockerAvailable();
    }
  }, {
    key: "showLocationPermissionPopup",
    get: function get() {
      return this._showLocationPermissionPopup;
    },
    set: function set(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._showLocationPermissionPopup = val;
      });
    }
  }]);

  return Root;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "error", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "menuList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_refreshInProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_initInProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_winWidth", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_winHeight", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_documentHeight", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_styleCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_keyboardShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_lastPauseTimeStamp", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_marketingCloudVisitorId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "reloadInProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_showLocationPermissionPopup", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_timeSinceStartup", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isMobile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMobile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "acceptClientType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "acceptClientType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearAll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearAll"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "timeSinceStartup", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "timeSinceStartup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "lastPauseTimeStamp", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "lastPauseTimeStamp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyboardShow", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "keyboardShow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onAppLayout", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onAppLayout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orientation", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orientation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWineListAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWineListAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isWineLockerAvailable", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isWineLockerAvailable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onStateChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onStateChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showError"), _class.prototype)), _class);
export { Root as default };